import React from 'react';
import { X, Award } from 'lucide-react';
import { WheelData } from '../../../../types';
import { WHEEL_COLORS } from '../utils/wheelConfig';

interface LegendModalProps {
  isOpen: boolean;
  onClose: () => void;
  wheelData: WheelData;
}

const LegendModal: React.FC<LegendModalProps> = ({ isOpen, onClose, wheelData }) => {
  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-40"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full max-h-[80vh] overflow-hidden">
          {/* Header */}
          <div className="bg-gradient-to-r from-indigo-600 to-purple-600 p-6 text-white">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <Award className="w-6 h-6" />
                <h2 className="text-xl font-bold">Prêmios Disponíveis</h2>
              </div>
              <button
                onClick={onClose}
                className="p-1 hover:bg-white hover:bg-opacity-20 rounded-lg transition-colors"
              >
                <X className="w-6 h-6" />
              </button>
            </div>
          </div>

          {/* Content */}
          <div className="p-6 overflow-y-auto max-h-[calc(80vh-100px)]">
            <div className="space-y-3">
              {wheelData.products.map((product, index) => (
                <div
                  key={product.id}
                  className="flex items-center gap-3 p-3 rounded-lg border border-gray-200 hover:border-indigo-300 hover:shadow-md transition-all"
                >
                  {/* Color indicator */}
                  <div
                    className="w-8 h-8 rounded-lg flex-shrink-0 shadow-md border-2 border-white"
                    style={{ backgroundColor: WHEEL_COLORS[index % WHEEL_COLORS.length] }}
                  />

                  {/* Product info */}
                  <div className="flex-1 min-w-0">
                    <p className="font-semibold text-gray-900">
                      {product.name}
                    </p>
                    {product.description && (
                      <p className="text-sm text-gray-500">
                        {product.description}
                      </p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Footer */}
          <div className="p-4 bg-gray-50 border-t border-gray-200">
            <p className="text-sm text-gray-600 text-center">
              Total de <strong>{wheelData.products.length}</strong> prêmio{wheelData.products.length !== 1 ? 's' : ''} disponíve{wheelData.products.length !== 1 ? 'is' : 'l'}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default LegendModal;
